import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// import { CustomValidators } from '../../../../utils/validators/customValidators';

@Component({
  selector: 'app-create-vs-card',
  templateUrl: './create-vs-card.component.html',
  styleUrls: ['./create-vs-card.component.scss']
})
export class CreateVsCardComponent implements OnInit {
  fileImg64: any;
  wrongSize: any;
  cardForm: FormGroup;
  maxLength = 350;

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  sendData(): any {
    this.cardForm.get('codeImg').setValue(Number(this.cardForm.value.codeImg));
    this.cardForm.get('order').setValue(Number(this.cardForm.value.order));
    const dataToSend = {
      ...this.cardForm.value
    };

    this.activeModal.close(dataToSend);
  }

  private createForm(): any {
    this.cardForm = this.fb.group({
      title: ['', Validators.required],
      order: [null, Validators.required],
      img: ['', Validators.required],
      img64: ['', Validators.required],
      subTitle: ['', Validators.required],
      codeImg: [3],
    });
  }

  getBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        if (image.width <= 200 && image.height <= 150) {
          this.wrongSize = null;
          this.fileImg64 = image.src;
          this.cardForm.get('img').setValue((event.target.files[0]).name);
          this.cardForm.get('img64').setValue(this.fileImg64.split(',')[1]);
        } else {
          this.wrongSize = 'Resolución de imagen no permitida (requerida: 200px x 150px)';
          return false;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }

}
